import React from "react";
import { Tag } from "antd";

const invoice_statuses = [
  { label: <Tag color="red">Oczekuje na płatność</Tag>, value: "pending" },
  {
    label: <Tag color="green">Opłacone</Tag>,
    value: "paid",
  },
];

export const filter_invoice_statuses = [
  { label: "Oczekuje na płatność", value: 0 },
  { label: "Opłacone", value: 1 },
];

export const getInvoiceStatus = (val) =>
  invoice_statuses.find(({ value }) => value === val)
    ?.label || "-";

export const getInvoiceStatusTag = (val) => {
  return invoice_statuses.find(({ value }) => value === val)?.label
};

export default invoice_statuses;
